import { useQuery } from '@apollo/client';
import { Box } from '@mui/material';
import { DueDiligenceProcessProvider } from 'components/DueDiligenceProcess/Context/DueDiligenceProcessContext';
import { Loader } from 'components/Forms';
import { ErrorState, PageContainer, PageTitle } from 'components/Structure';
import { usePageTitle } from 'components/hooks';
import { GET_LATEST_GEO_DATA_PROCESS } from 'graphql/secure/queries/dueDiligence.queries';
import React, { FC } from 'react';
import { useMatch, Navigate } from 'react-router-dom';
import { IGeoDataProcess } from 'types/geodata.types';
import { BooleanParam, useQueryParam } from 'use-query-params';

const EudrDueDiligenceProcess: FC = () => {
  usePageTitle('Due diligence process');
  const [isNewProcess] = useQueryParam('newProcess', BooleanParam);
  const { data, loading, error } = useQuery<{
    latestGeoDataProcess: IGeoDataProcess;
  }>(GET_LATEST_GEO_DATA_PROCESS, {
    skip: !!isNewProcess,
  });
  const latestDueDiligenceProcess = data?.latestGeoDataProcess;

  const isEmptyProcessRoute = useMatch('/compliance/eudr/guide');

  if (latestDueDiligenceProcess && !isNewProcess && isEmptyProcessRoute) {
    return <Navigate to={`/compliance/eudr/${latestDueDiligenceProcess.id}/guide`} />;
  }

  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <ErrorState />;
  }

  return (
    <PageContainer>
      <PageTitle
        title="Geo-data analysis guide"
        titleExtension="EUDR"
        goBackLabel="Compliance overview"
        goBackUrl="/compliance/eudr/due-diligence-progress"
      />

      <Box mb={3} />
      {/* The provider maintains the content and its children */}
      <DueDiligenceProcessProvider />
    </PageContainer>
  );
};

export default EudrDueDiligenceProcess;
